<template>
  <div class="serviceInventory-container">
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="bank" theme="filled" />
          <span>运维公司台账</span>
        </a-space>
      </template>
      <span>运维公司台账包含运维公司名称、联系人等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected"
        :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']"
        :refresh="refresh"
        :search-type-options="[
          { label: '运维公司名称', value: 'name' },
          { label: '运维公司负责人', value: 'manager' },
          { label: '运维公司负责人联系电话', value: 'phone_number' }
        ]"
      >
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.inventory.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          ></create-button>
        </template>
        <template #rightTool>
          <upload-button
            v-permission="{action: 'base.inventory.update'}"
            @click="$refs.uploadModal.show()"
          ></upload-button>
        </template>

        <template #operation="{ slotProps }">
          <edit-button
            v-permission="{action: 'base.inventory.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <delete-button
            v-permission="{action: 'base.inventory.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getOperationCompanyList,
  deleteOperationCompany,
  exportOperationCompany
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'OperationCompany',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data () {
    return {
      getTableDataFunc: getOperationCompanyList,
      exportFunc: exportOperationCompany,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '运维公司名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'manager',
          title: '运维公司负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'manager'
          }
        },
        {
          dataIndex: 'phone_number',
          title: '运维公司负责人联系电话',
          width: 160,
          scopedSlots: {
            customRender: 'phoneNumber'
          }
        }
      ],
      columnDefaultSelected: [
        'name',
        'manager',
        'phone_number'
      ]
    }
  },
  created () {
    // this.fetch()
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteOperationCompany(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm () {
      this.refresh = !this.refresh
    }
  }
}
</script>
